'use strict';

var jQuery = require('jquery');
var React = require('react');
var ReactDOM = require('react-dom');

var isNode = typeof document === 'undefined';
if (!isNode) {
    require('../styles/responsive.scss');
}

var Constants = require('../constants');

var ResponsiveMixin = {
    getInitialState: function() {
        return this._state();
    },
    componentWillMount: function() {
        this._updateClientState();
    },
    componentDidMount: function() {
        window.addEventListener('resize', this._onResize);
    },
    componentWillUnmount: function() {
        window.removeEventListener('resize', this._onResize);
    },
    _onResize: function() {
        this._updateClientState(function() {
            if (this.componentDidResize) {
                this.componentDidResize();
            }
        });
    },
    _updateClientState: function(callback) {
        this.setState(this._state(), callback);
    },
    _state: function() {
        var w = window.innerWidth;
        var h = window.innerHeight;
        var layout;
        if (w <= Constants.Breaks.MobilePortraitMax && h >= w) {
            layout = 'portrait';
        } else if (w <= Constants.Breaks.MobileLandscapeMax && w >= h) {
            layout = 'landscape';
        } else {
            layout = 'desktop';
        }
        return {
            viewportLayout: layout,
            viewportWidth:  w,
            viewportHeight: h,
        };
    },
};

if (!isNode) {
    module.exports = ResponsiveMixin;
} else {
    // Very important: search engine crawlers see desktop site
    module.exports = {
        getInitialState: function() {
            return {
                viewportLayout: 'desktop',
                viewportWidth: Constants.Breaks.DesktopWidth,
                viewportHeight: 690,  // doesn't matter
            };
        },
    };
}



// WEBPACK FOOTER //
// ./src/global/responsive.jsx